import { render } from "./DoctorForm.vue?vue&type=template&id=31c5d70c&scoped=true"
import script from "./DoctorForm.vue?vue&type=script&lang=js"
export * from "./DoctorForm.vue?vue&type=script&lang=js"

import "./DoctorForm.vue?vue&type=style&index=0&id=31c5d70c&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c5d70c"]])

export default __exports__